export const ASK_YOGI_URL = 'ask-yogi'
export const ASK_YOGI_CONVERSATION_URL = 'ask-yogi-conversation'
export const ASK_YOGI_SHARE_URL = 'ask-yogi-share'

export const ASK_YOGI_TRANSACTION_PATH = `/project/:id/${ASK_YOGI_URL}`
export const ASK_YOGI_CONVERSATION_TRANSACTION_PATH = `/project/:id/${ASK_YOGI_URL}/:conversationId`
export const ASK_YOGI_SHARE_TRANSACTION_PATH = `/project/:id/${ASK_YOGI_URL}/:conversationId/share`

export const askYogiPath = (projectId: string): string =>
  `/project/${projectId}/${ASK_YOGI_URL}`

export const askYogiConversationPath = (
  projectId: string,
  conversationId: string,
): string => `/project/${projectId}/${ASK_YOGI_URL}/${conversationId}`

export const askYogiSharePath = (
  projectId: string,
  conversationId: string,
): string => `/project/${projectId}/${ASK_YOGI_URL}/${conversationId}/share`
